var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-icon-button/src/IconButtonPure.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { css as glamorCss } from 'glamor';

var getLabel = function getLabel(dataE2E, id, label, styles) {
  return React.createElement("div", _extends({
    "data-e2e": "".concat(dataE2E, "-icon-button-label-").concat(label),
    id: "".concat(id, "-icon-button-label-").concat(label)
  }, glamorCss(styles), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: this
  }), label);
};

var IconButtonPure = function IconButtonPure(_ref) {
  var checked = _ref.checked,
      dataE2E = _ref['data-e2e'],
      disabled = _ref.disabled,
      icon = _ref.icon,
      id = _ref.id,
      inline = _ref.inline,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      onCheck = _ref.onCheck,
      showLabel = _ref.showLabel,
      styles = _ref.styles;
  var container = styles.container,
      containerInline = styles.containerInline,
      containerLeft = styles.containerLeft,
      iconStyle = styles.iconStyle,
      iconStyleChecked = styles.iconStyleChecked,
      iconStyleDisabled = styles.iconStyleDisabled,
      labelStyleLeft = styles.labelStyleLeft,
      labelStyleLeftDisabled = styles.labelStyleLeftDisabled,
      labelStyleRight = styles.labelStyleRight,
      labelStyleRightDisabled = styles.labelStyleRightDisabled;
  var appliedContainerLeft = labelPosition === 'left' ? containerLeft : container;
  var appliedContainer = inline ? containerInline : appliedContainerLeft;
  var appliedChecked = checked ? iconStyleChecked : iconStyle;
  var appliedIcon = disabled ? iconStyleDisabled : appliedChecked;
  var appliedLeft = disabled ? labelStyleLeftDisabled : labelStyleLeft;
  var appliedRight = disabled ? labelStyleRightDisabled : labelStyleRight;
  var appliedLabel = labelPosition === 'left' ? appliedLeft : appliedRight;
  return React.createElement("button", _extends({
    "data-e2e": dataE2E,
    disabled: disabled,
    id: id,
    onClick: function onClick(event) {
      return onCheck(event, label);
    }
  }, glamorCss(appliedContainer), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }), labelPosition === 'left' && showLabel && getLabel(dataE2E, id, label, appliedLabel), React.createElement(FontAwesomeIcon, _extends({
    "data-e2e": "".concat(dataE2E, "-icon"),
    id: "".concat(id, "-icon"),
    icon: icon
  }, glamorCss(appliedIcon), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58
    },
    __self: this
  })), labelPosition !== 'left' && showLabel && getLabel(dataE2E, id, label, appliedLabel));
};

IconButtonPure.propTypes = {
  /** State of icon button. */
  checked: PropTypes.bool,

  /** Passed down to all children to allow for E2E testing. */
  'data-e2e': PropTypes.string,

  /** If true, icon button is disabled. */
  disabled: PropTypes.bool,

  /** Font awesome icon to use as button. */
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.element, PropTypes.object, PropTypes.string]),

  /** Passed down to all DOM elements to allow E2E testing. */
  id: PropTypes.string,

  /** If true, icon button is inline. */
  inline: PropTypes.bool,

  /** Icon button label. */
  label: PropTypes.string,

  /** Position of icon button label. */
  labelPosition: PropTypes.string,

  /** Callback fired on check. */
  onCheck: PropTypes.func,

  /** If true, label is visible. */
  showLabel: PropTypes.bool,

  /** Applied styles. */
  styles: PropTypes.shape({
    container: PropTypes.shape({}),
    containerInline: PropTypes.shape({}),
    containerLeft: PropTypes.shape({}),
    iconStyle: PropTypes.shape({}),
    iconStyleChecked: PropTypes.shape({}),
    iconStyleDisabled: PropTypes.shape({}),
    labelStyleLeft: PropTypes.shape({}),
    labelStyleLeftDisabled: PropTypes.shape({}),
    labelStyleRight: PropTypes.shape({}),
    labelStyleRightDisabled: PropTypes.shape({})
  })
};
IconButtonPure.defaultProps = {
  onCheck: function onCheck() {},
  showLabel: true,
  styles: {
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    },
    containerInline: {},
    containerLeft: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    iconStyle: {},
    iconStyleChecked: {},
    iconStyleDisabled: {},
    labelStyleLeft: {
      paddingRight: '8px'
    },
    labelStyleLeftDisabled: {
      paddingRight: '8px'
    },
    labelStyleRight: {
      paddingLeft: '8px'
    },
    labelStyleRightDisabled: {
      paddingLeft: '8px'
    }
  }
};
IconButtonPure.displayName = 'IconButtonPure';
export default IconButtonPure;